import { Action } from "../../../actions/actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { AuthActionTypes } from "../actions/actionTypes";
import { authAPI } from "../api/auth.api";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { API } from "../../../api/api";
import { authMessagesStrings } from "../assets/authMessages.strings";
import { HomeActionTypes } from "../../home/actions/actionTypes";
import { homeStore } from "../../home/store/store";

function* getUsers(action: Action) {
    try {
        const data = yield call(authAPI.getUsers, action.payload);
        yield put({
            type: AuthActionTypes.GET_USERS_LIST_SUCCESS,
            payload: data.data
        });
    } catch (e) {
        ToasterService.errorToast("Error getting users list.");

        API.handleError(e.response);

        yield put({
            type: AuthActionTypes.GET_USERS_LIST_FAIL,
            message: e.message
        });
    }
}

export function* getUsersWatcher() {
    yield takeLatest(AuthActionTypes.GET_USERS_LIST, getUsers);
}

function* changeUserStatus(action: Action) {
    try {
        const { user_id, search_json } = action.payload;
        yield call(authAPI.changeUserStatus, user_id);
        ToasterService.successToast(
            authMessagesStrings.CHANGE_USER_STATUS_SUCCESS
        );

        yield put({
            type: AuthActionTypes.GET_USERS_LIST,
            payload: search_json
        });
    } catch (e) {
        ToasterService.errorToast("Error changing the user status.");
        API.handleError(e.response);
        yield put({
            type: AuthActionTypes.CHANGE_USER_STATUS_FAIL,
            error: e.message
        });
    }
}

export function* changeUserStatusWatcher() {
    yield takeLatest(AuthActionTypes.CHANGE_USER_STATUS, changeUserStatus);
}

function* editUser(action: Action) {
    try {
        const { user_id, user_info, search_json } = action.payload;
        yield call(authAPI.editUser, user_id, user_info);
        ToasterService.successToast(authMessagesStrings.EDIT_USER_SUCCESS);

        if (search_json) {
            yield put({
                type: AuthActionTypes.GET_USERS_LIST,
                payload: search_json
            });
        }

        homeStore.dispatch({
            type: HomeActionTypes.GET_USER_INFO
        });
    } catch (e) {
        API.handleError(e.response, "Error editing user.");

        yield put({
            type: AuthActionTypes.EDIT_USER_FAIL,
            error: e.message
        });
    }
}

export function* editUserWatcher() {
    yield takeLatest(AuthActionTypes.EDIT_USER, editUser);
}

function* editUserPassword(action: Action) {
    try {
        const { user_id, user_info } = action.payload;
        yield call(authAPI.editUser, user_id, {
            password: user_info.password,
            new_password: user_info.new_password
        });

        ToasterService.successToast(
            authMessagesStrings.EDIT_USER_PASSWORD_SUCCESS
        );

        homeStore.dispatch({
            type: HomeActionTypes.GET_USER_INFO
        });
    } catch (e) {
        API.handleError(e.response, "Error Changing Password.");

        yield put({
            type: AuthActionTypes.EDIT_USER_PASSWORD_FAIL,
            error: e.message
        });
    }
}

export function* editUserPasswordWatcher() {
    yield takeLatest(AuthActionTypes.EDIT_USER_PASSWORD, editUserPassword);
}

function* createUser(action: Action) {
    try {
        const { user_info, search_json } = action.payload;
        yield call(authAPI.createUser, user_info);

        ToasterService.successToast(authMessagesStrings.CREATE_USER_SUCCESS);

        yield put({
            type: AuthActionTypes.GET_USERS_LIST,
            payload: search_json
        });
    } catch (e) {
        ToasterService.errorToast("Error creating user.");
        API.handleError(e.response);
        yield put({
            type: AuthActionTypes.CREATE_USER_FAIL,
            error: e.message
        });
    }
}

export function* createUserWatcher() {
    yield takeLatest(AuthActionTypes.CREATE_USER, createUser);
}
